/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { AccordionComponentContextWrapper } from "cms/components/components/accordion/edit/accordion-context-wrapper";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import LabelledField from "components/labelled-field";
import { FieldErrorFallback } from "../../../../fields/layout/field-error";
import { ErrorBoundary } from "react-error-boundary";

const AccordionComponentEditor = () => {
    const { component, update, updateFactory } = useUpdateComponent();

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };

    const onChangeDescription = (event) => {
        const description = event.target.value;
        update("description", description);
    };

    const onChangeShowSteps = (event) => {
        const showSteps = event.target.checked;
        update("showSteps", showSteps);
    };

    const onChangeSections = updateFactory("sections");

    return (
        <div className='simplicity-editor-frame'>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload(); 
                }}
            >
                <LabelledField label='Title'>
                    <TextField
                        onChange={onChangeTitle}
                        fullWidth
                        value={component.title}
                    />
                </LabelledField>

                <LabelledField label='Description'>
                    <TextField
                        onChange={onChangeDescription}
                        fullWidth
                        value={component.description}
                    />
                </LabelledField>

                <AccordionComponentContextWrapper
                    sections={component.sections}
                    showSteps={component.showSteps}
                    onChangeSections={onChangeSections}
                    onChangeShowSteps={onChangeShowSteps}
                />
            </ErrorBoundary>
        </div>
    );
};

AccordionComponentEditor.displayName = "AccordionComponentEditor";
export { AccordionComponentEditor };
